import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import FontAwesome from 'utils/FA';
import { duckify } from 'utils/duckify';
import PageHeader from 'components/PageHeader';
import { delayedJobs } from 'ducks/index';

import JobsTable from './JobsTable';

import './styles/delayed_jobs.scss';
import { QueueSummaryTable } from './QueueSummaryTable';

const DelayedJobs = ({ delayedJobs, fetchJobs }) => {
  const jobsByQueue = {};

  Object.keys(delayedJobs.queueSummaries)
    .forEach((queue) => {
      jobsByQueue[queue] = delayedJobs.filter((job) => job.queue === queue);
    });

  return (
    <div className={delayedJobs.fetching ? 'delayed-jobs-loading' : ''}>
      <div>
        <PageHeader header='Delayed Jobs' className='delayed-jobs-header' />
        <button
          className='delayed-jobs-header-refresh btn btn-success btn-sm'
          disabled={delayedJobs.fetching}
          type='button'
          onClick={() => fetchJobs()}
        >
          <FontAwesome name='repeat' />
        </button>
      </div>
      <QueueSummaryTable queueSummaries={delayedJobs.queueSummaries} />
      <div className='delayed-jobs-failed-count'>
        <strong>Failing Job Count: </strong>
        {delayedJobs.failedCount}
      </div>
      {
        Object.entries(jobsByQueue)
          .map(([queue, jobs]) => <JobsTable queue={queue} jobs={jobs} key={queue} />)
      }
    </div>
  );
};

const mapDucksToProps = () => ({
  delayedJobs
});

const mapDispatchToProps = (dispatch) => ({
  fetchJobs: () => dispatch(delayedJobs.actions.load())
});

DelayedJobs.propTypes = {
  /** A list of delayed jobs */
  delayedJobs: PropTypes.array,

  /** Fetches delayed jobs from the server */
  fetchJobs: PropTypes.func
};

DelayedJobs.defaultProps = {
  delayedJobs: [],
  fetchJobs: () => false
};

export default withRouter(duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(DelayedJobs));
